export const formatFrequencyUnit = (input) => {
  if (!input || typeof input !== "string") return "INVALID";

  const mapping = {
    day: "DAILY",
    daily: "DAILY",
    week: "WEEKLY",
    weekly: "WEEKLY",
    month: "MONTHLY",
    monthly: "MONTHLY",
    year: "YEARLY",
    yearly: "YEARLY",
    quarter: "QUARTERLY",
    quarterly: "QUARTERLY",
    once: "ONCE",
  };

  const normalized = input.trim().toLowerCase();
  return mapping[normalized] || "INVALID";
}

export const formatDateOnly = (dateInput, outputTimeZone = 'America/Sao_Paulo') => {
  if (!dateInput) return '';

  try {
    let date;
    
    // Handle different input formats
    if (typeof dateInput === 'string') {
      // Check if it's an ISO string (YYYY-MM-DD format)
      if (dateInput.match(/^\d{4}-\d{2}-\d{2}/)) {
        date = new Date(dateInput);
      } 
      // Handle MM/DD/YYYY or DD/MM/YYYY format
      else if (dateInput.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
        const parts = dateInput.split('/');
        // Assuming the input is MM/DD/YYYY and we want to interpret it correctly
        // If you want DD/MM/YYYY interpretation, change the order below
        const month = parseInt(parts[0], 10) - 1; // Month is 0-indexed
        const day = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        // Use UTC to avoid timezone shifts for date-only operations
        date = new Date(Date.UTC(year, month, day));
      }
      else {
        date = new Date(dateInput);
      }
    } else {
      date = new Date(dateInput);
    }

    // Check if date is valid
    if (isNaN(date.getTime())) {
      console.error('Invalid date:', dateInput);
      return '';
    }

    // For date-only formatting, don't apply timezone to avoid shifts
    const formatter = new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC', // Use UTC to prevent date shifts
    });

    return formatter.format(date); // e.g., "23/05/2025"
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
}

/**
 * Darkens a hex color by a specified percentage
 * @param {string} color - Hex color (e.g., "#FF5733" or "FF5733")
 * @param {number} percent - Percentage to darken (0-100, default 20)
 * @returns {string} Darkened hex color
 */
export const darkenColor = (color, percent = 20) => {
  if (!color) return '#000000';
  
  // Remove # if present
  let hex = color.replace('#', '');
  
  // Convert 3-digit hex to 6-digit
  if (hex.length === 3) {
    hex = hex.split('').map(char => char + char).join('');
  }
  
  // Invalid hex color, return dark grey
  if (hex.length !== 6 || !/^[0-9A-F]+$/i.test(hex)) {
    return '#333333';
  }
  
  // Convert to RGB
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  // Calculate darkened values
  const factor = (100 - percent) / 100;
  const newR = Math.round(r * factor);
  const newG = Math.round(g * factor);
  const newB = Math.round(b * factor);
  
  // Convert back to hex
  const toHex = (value) => {
    const hex = value.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };
  
  return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
};

export const CALLBACK_EVENT_TYPE = "ALTRUON_CHECKOUT_EVENT";

export const CALLBACKS = {
  SUCCESS: "onSuccess",
  FAILURE: "onFailure",
  DATA_REQUIRED: "onDataRequired",
  ACTION_REQUIRED: "onActionRequired",
};


export const triggerCallback = (type, payload = {}) => {
  if (window.parent && window.parent !== window) {
    window.parent.postMessage(
      {
        source: "altruon-checkout",
        type,
        payload,
      },
      "*"
    );
  }
};
